import type { FaireProductEntity } from "../../entity_types/product";

export const p_p7s7zp72wt: FaireProductEntity = {
  token: "p_p7s7zp72wt",
  type: "product",
  name: "Custom Toddler Kids Crewneck Sweatshirt",
  brandToken: "b_6zj4dcu23e",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/74a1b0203d58ee58adc683ff93de403d3eb30f22c60514f3eefc9038d3151c7f.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/37c9650f856ed4ea86ac27e2b67fd73d5427dc80e6eb7ef36592697c7d52315e.jpeg",
    "https://cdn.faire.com/fastly/71c7a84f84c34a0e71aedfc3326014327a701c10c5e4e6443124ad9f4b9b9b46.png",
    "https://cdn.faire.com/fastly/c5183a46ac68511df7540e5975bfdb9c3303eda6a27bee70955aba9ab44a3a7d.png",
    "https://cdn.faire.com/fastly/234a9d73b0e92df1a610aca684a2f83c9262fc8de5d5865b222b19225eba7621.png",
    "https://cdn.faire.com/fastly/c47143e1539fc92beb9a29107245d2855de50c6999010e779793fb414a335590.png",
  ],
  priceDollars: 31.87,
  description:
    "We can Customize designed to your specific needs. Events, parties, company name . We can do it.\n\n- These patches have been ironed on and heat pressed, not embroidered. But reassured they won't come off even after wash! \n- Material: 50% Cotton, 50% Polyester\n- Our Shirt material is super soft and comfy!\n\nIMPORTANT! Please be mindful that we do not accept returns, exchange or order cancellations because all of our items are made to order. \n\nHandmade with love in Chicago. Support small businesses. Shop small. ♡\n\nCustom Kids Shirt, Custom Kids Tee, Custom Toddlers Sweatshirt, Custom Toddlers Shirt.",
  tags: [],
  msrpDollars: 63.74,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:26:12.899Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
